import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { HolidaysQueryParams } from '../types';

/** Owner/Admin only. */
export function useHolidays(params: HolidaysQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.holidays(orgId, params.year),
    queryFn: ({ signal }) => timeOffService.getHolidays(params, signal),
    staleTime: 300_000,
    enabled: !!orgId,
  });
}
